import _toConsumableArray from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";

Array.fromLength = function (length) {
  return _toConsumableArray(Array(length + 1).keys());
};

export var ArrayToJson = function ArrayToJson(array) {
  var json = {};
  array.forEach(function (item, index) {
    json[index + 1] = item;
  }); // const JsonToServer = JSON.stringify(json);

  return json;
};